module.exports = __webpack_public_path__ + "img/34.8adc94fb.jpg";